import { ThemeColor } from '@/enums'
import { Close } from '@/icons'
import { forwardRef, ReactNode } from 'react'
import { ImageFromCdn } from '../../atoms'
import { WithMask } from '../../hoc/WithMask'
import {
  CloseModalButton,
  Container,
  ImageContainer,
  ModalContent,
  TextContent,
} from './styles'

export interface PictureModalProps {
  isOpen: boolean
  children?: ReactNode
  closable?: boolean
  onClose: () => void
  image: string
  shouldRenderInPortal?: boolean
}

export const PictureModal = forwardRef(
  (
    {
      isOpen,
      children,
      closable,
      onClose,
      image,
      shouldRenderInPortal = true,
    }: PictureModalProps,
    ref,
  ) => (
    <WithMask
      closable={closable}
      isOpen={isOpen}
      onClose={onClose}
      shouldRenderInPortal={shouldRenderInPortal}
    >
      <Container ref={ref}>
        {onClose && (
          <CloseModalButton onClick={onClose}>
            <Close color={ThemeColor.b0} height={12} width={12} />
          </CloseModalButton>
        )}
        {children && (
          <ModalContent>
            <TextContent>{children}</TextContent>
            <ImageContainer>
              <ImageFromCdn fallbackType="jpg" name={image} type="webp" />
            </ImageContainer>
          </ModalContent>
        )}
      </Container>
    </WithMask>
  ),
)

PictureModal.displayName = 'PictureModal'
